import { Toggle, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { type ComponentProps } from 'react'
import { cn } from '~/utils'

interface ToolbarButtonProps extends ComponentProps<typeof Toggle> {
  isActive?: boolean
  tooltip?: string
  tooltipOptions?: ComponentProps<typeof TooltipContent>
}

export const ToolbarButton = ({
  ref,
  isActive,
  children,
  tooltip,
  className,
  tooltipOptions,
  ...props
}: ToolbarButtonProps) => {
  const toggleButton = (
    <Toggle size="sm" ref={ref} className={cn('size-8 p-0', { 'bg-accent': isActive }, className)} {...props}>
      {children}
    </Toggle>
  )

  if (!tooltip) {
    return toggleButton
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{toggleButton}</TooltipTrigger>
        <TooltipContent {...tooltipOptions}>
          <div className="flex flex-col items-center text-center">{tooltip}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

ToolbarButton.displayName = 'ToolbarButton'

export default ToolbarButton
